module.exports = __webpack_public_path__ + "static/joao-ec4b2309737da835e16098bf50201a4f.jpg";